import type { ReactElement } from 'react'
import { Vector3 } from 'three'
import { useResultsStore } from '@editorStores'
import {
  isSelectedSupportHighlightMatch,
  toggleSelectedSupportHighlight,
} from '../../../Results2DetailPane/utils'
import SceneLabelChip from '../SceneLabelChip'

export type SupportSceneLabelItem = {
  id: string
  relativePosition: string
  p: Vector3
  n: number
}

type Props = {
  items: SupportSceneLabelItem[]
  elementGuidForSupports: string | null
  showFloorplan: boolean
}

const SupportSceneLabels = ({
  items,
  elementGuidForSupports,
  showFloorplan,
}: Props): ReactElement | null => {
  const highlightedCheck = useResultsStore(state => state.highlightedCheck)
  const setHighlightedCheck = useResultsStore(state => state.setHighlightedCheck)

  if (!elementGuidForSupports || items.length === 0) return null

  return (
    <group position={[0, showFloorplan ? -0.15 : 0, 0]}>
      {items.map(item => {
        const isHighlighted = isSelectedSupportHighlightMatch(
          elementGuidForSupports,
          highlightedCheck,
          item.relativePosition,
        )

        return (
          <SceneLabelChip
            key={item.id}
            position={item.p}
            highlighted={isHighlighted}
            showFloorplan={showFloorplan}
            onClick={() =>
              toggleSelectedSupportHighlight(
                elementGuidForSupports,
                item.relativePosition,
                highlightedCheck,
                setHighlightedCheck,
              )
            }
          >
            A {item.n}
          </SceneLabelChip>
        )
      })}
    </group>
  )
}

export default SupportSceneLabels
